export default "__VITE_ASSET__De3mf$Wf__"